// extracted by mini-css-extract-plugin
module.exports = {"social-login-button":"UdIh1v8p","socialLoginButton":"UdIh1v8p","icon-wrapper":"Dq9YZ6wU","iconWrapper":"Dq9YZ6wU"};